import { removeChildren } from "../../../lib/util";
import FormFieldHelper from "../FormFieldHelper";
import FormFieldComponent from "./_FormFieldComponent";

export default class ChildInformationFormFieldComponent extends FormFieldComponent {
    static FieldsetFieldsSelector = "input:not([type='hidden'])";
    static HideCssClass = "hide";

    field;
    fieldAlias;
    items;
    constructor(el) {
        super(el);

        this.field = this.el.querySelector('[data-umb-field-alias]');
        this.items = this.field.querySelectorAll('[data-umb-field-item]');
        this.fieldAlias = this.field.dataset.umbFieldAlias;

        const validator = FormFieldHelper.getChildInformationFieldValidator(this.field);
        if (typeof (validator) !== 'undefined') {
            this.validators.push(validator);
        }

        this.#init();
    }

    #init() {
        const elementsToHide = this.field.querySelectorAll("fieldset[data-child-information]:not([data-child-information = '0'])");
        elementsToHide.forEach((fieldset) => {
            const inputs = Array.from(fieldset.querySelectorAll(ChildInformationFormFieldComponent.FieldsetFieldsSelector));
            const hasNoValues = inputs.every(x => typeof (x.value) === 'undefined' || x.value.length === 0);

            if (hasNoValues) {
                fieldset.classList.add(ChildInformationFormFieldComponent.HideCssClass);
            }
        });

        this.#initEvents();
    }

    #initEvents() {
        this.field.querySelector('button[data-add-child-btn]').addEventListener('click', function (e) {
            e.preventDefault();
            const nextChildEl = document.querySelector("[data-child-information].hide");

            if (nextChildEl === null) {
                return;
            }

            nextChildEl.classList.remove("hide");
        });

        this.field.querySelector('button[data-remove-child-btn]').addEventListener('click', function (e) {
            e.preventDefault();

            const lastVisibleChildEl = document.querySelector(":nth-last-child(1 of [data-child-information]:not(.hide))");

            if (lastVisibleChildEl === null) {
                return;
            }

            const { childInformation: index } = lastVisibleChildEl.dataset;

            if (index === "0") {
                return;
            }

            lastVisibleChildEl.classList.add("hide");

            const inputs = Array.from(lastVisibleChildEl.querySelectorAll(ChildInformationFormFieldComponent.fieldsetFieldsSelector));
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].value = '';
            }
        });
    }

    getValue() {
        const values = [];
        const elements = this.field.querySelectorAll("fieldset[data-child-information]:not(.hide)");

        elements.forEach((element, index) => {
            const firstName = element.querySelector('input[name$=".FirstName"]');
            const lastName = element.querySelector('input[name$=".LastName"]');
            const birthDate = element.querySelector('input[name$=".BirthDate"]');

            values.push({
                'fieldNamePrefix': `ChildInformation[${index}]`,
                'firstName': firstName?.value,
                'lastName': lastName?.value,
                'birthDate': birthDate?.value
            });
        });

        console.log(values);

        return values;
    }

    getFieldAlias() {
        return this.fieldAlias;
    }

    #createErrorSummary = (parent) => {
        const element = document.createElement('ul');
        element.classList.add('formulate__inline-validation-summary');
        parent.appendChild(element);

        return element;
    }

    showValidationError(messages) {
        this.hideValidationError();

        messages.forEach((message) => {
            const { text, fieldName } = message;
            const input = this.field.querySelector(`[name='${fieldName}']`);
            const field = input.closest('.formulate__field');

            if (field === null) {
                return;
            }

            field.classList.add('formulate__field--validation-error');
            let summary = field.querySelector('.formulate__inline-validation-summary');

            if (summary === null) {
                summary = this.#createErrorSummary(field);
            }

            const messageEl = document.createElement('li');
            messageEl.innerText = text;

            summary.appendChild(messageEl);
        });
    }

    clearValidationMessages() {
        const parents = this.el.querySelectorAll('.formulate__inline-validation-summary');

        parents.forEach((parent) => {
            removeChildren(parent);
        });
    }
}